var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qcDetailPage"},[_c('div',{staticClass:"page_cards"},[_c('case-risk',{attrs:{"caseDetail":_vm.caseDetail},on:{"goBack":_vm.goBack}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }